import { Fail } from './fail';

export class UnauthorizedFail extends Fail {
  _message = 'Required authorization';
}
